import React from 'react';
import { gql } from '@apollo/client';
import { BooleanField, Show, SimpleShowLayout, TextField, useShowController } from 'react-admin';
import { JsonField } from 'react-admin-json-view';
import LinkField from 'components/LinkField';

const QualificationAttributeShow = () => {
  const { record } = useShowController();
  const isSystemSource = record?.input_source === 'system';

  return (
    <Show actions={isSystemSource ? false : undefined}>
      <SimpleShowLayout>
        <TextField source="id" />
        <LinkField source="qualification.id" label="Qualification ID" />
        <TextField source="name" />
        <TextField source="slug" />
        <TextField source="field_type" />
        <BooleanField source="required" />
        <BooleanField source="required_for_approval" />
        <JsonField source="data" />
      </SimpleShowLayout>
    </Show>
  );
};

QualificationAttributeShow.query = gql`
  query GET_ONE($id: Int!) {
    qualificationAttribute(id: $id) {
      data
      field_type
      id
      input_source
      name
      required
      required_for_approval
      slug
      qualification {
        id
      }
    }
  }
`;

export default QualificationAttributeShow;
